export default "__VITE_ASSET__CPfdUJPc__"